import React, {Component} from 'react'

import TextField from '@material-ui/core/TextField'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import ArtistsPanel from "./EditShowDialog/ArtistsPanel"
import SelectUserDialog from "./../../users/SelectUserDialog"

import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'

import Button from '@material-ui/core/Button'

import {Grid} from '@material-ui/core'

import CodeNotFoundDialog from './EditShowDialog/CodeNotFoundDialog'
import api from '../../api'

/**
 * <EditShowDialog show onUpdateShow = {show} onCancel = {} />
 */

class EditShowDialog extends Component {

	constructor(props) {
		super(props)

		this.state = {
			name: "",
			address: "",
			date: "0001-01-01",
			time: "00:00",
			artists: [],
			dialog: undefined,
			artistsChanged: undefined,
			boxBig: 0,
			boxMedium: 0,	
			box_code: "",
		}

		this._box_code = ""

		this.handleSelectArtistClick = this.handleSelectArtistClick.bind(this)
		this.handleRemoveArtistClick = this.handleRemoveArtistClick.bind(this)
		this.handleBoxBigSelectChange = this.handleBoxBigSelectChange.bind(this)
		this.handleBoxMediumSelectChange = this.handleBoxMediumSelectChange.bind(this)		
	}

	getCurrentDate() {
		let date = new Date()
		let year = date.getFullYear()
		let month = date.getMonth() + 1
		let day = date.getDate()
		return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
	}

	getCurrentTime() {
		let date = new Date()
		let hours = date.getHours()
		let minutes = date.getMinutes()
		return `${hours < 10 ? `0${hours}` : `${hours}`}:${minutes < 10 ? `0${minutes}` : `${minutes}`}`
	}

	normalizeTime(time) {
		if (typeof time === "string") {
			switch (time.length) {
				case 5:
					return `${time}:00`
				case 8:
					return time
				default:
					return "00:00:00"
			}
		}
		return "00:00:00"
	}

	componentDidMount = async () => {
		if (this.props.show) {

			if (this.props.show.box_id > 0) {
				var { box } = await api.boxes.get(this.props.show.box_id)
			} else {
				var box = {
					id: 0,
					code: "",
				}
			}
			
			// Сохраняем оригинал кода коробки для мониторинга изменений,
			// так как он не является частью this.props.show.
			this._box_code = box.code

			let splittedDate = this.props.show.date.split(" ")

			this.setState({
				name: this.props.show.name,
				address: this.props.show.address,
				date: splittedDate[0],
				time: splittedDate[1],
				artists: this.props.show.artists.slice(0),
				artistsChanged: false,
				boxBig: this.props.show.boxBig,
				boxMedium: this.props.show.boxMedium,
				box_code: box.code,
			})
			
		}
	}

	readyToUpdate() {
		
		if (this.state.box_code === "") {
			return false
		}
		if (this.state.box_code !== this._box_code) {
			return true
		}

		if (this.state.name === "") {
			return false
		}
		if (this.state.address === "") {
			return false
		}
		if (this.state.artistsChanged) {
			return true
		}
		if (this.state.name !== this.props.show.name) {
			return true
		}
		if (this.state.address !== this.props.show.address) {
			return true
		}
		if (`${this.state.date} ${this.normalizeTime(this.state.time)}` !== this.props.show.date) {
			return true
		}
		if (this.state.boxBig.toString() !== this.props.show.boxBig.toString()) {
			return true
		}
		if (this.state.boxMedium.toString() !== this.props.show.boxMedium.toString()) {
			return true
		}
		return false
	}

	handleSelectArtistClick() {
		this.setState({
			dialog: <SelectUserDialog
				filter = {[4]}
				onSelectUser = {user => {
					this.state.artists.push(user)
					this.setState({
						artistsChanged: true,
						dialog: undefined,
					})
				}}
				onCancel = {() => {
					this.setState({
						dialog: undefined
					})
				}}
			/>
		})
	}

	handleRemoveArtistClick(artist) {
		this.setState({
			artistsChanged: true,
			artists: this.state.artists.filter(a => a !== artist),
		})
	}

	handleBoxBigSelectChange(event) {
		this.setState({boxBig: event.target.value})
	}

	handleBoxMediumSelectChange(event) {
		this.setState({boxMedium: event.target.value})
	}	

	render() {

		if (this.state.dialog) {
			return this.state.dialog
		}

		return <Dialog open fullWidth>
			<DialogTitle>Редактировать шоу</DialogTitle>
			<DialogContent style = {{display: "flex", flexDirection: "column"}}>

				<ArtistsPanel
					artists = {this.state.artists}
					onSelectArtistClick = {this.handleSelectArtistClick}
					onRemoveArtistClick = {this.handleRemoveArtistClick}
				/>

				<TextField
					value = {this.state.name}
					label = "Название шоу"
					margin = "normal"
					onChange = {e => {
						e.preventDefault()
						this.setState({
							name: e.target.value
						})
					}}
				/>

				<TextField
					value = {this.state.address}
					label = "Адрес"
					margin = "normal"
					onChange = {e => {
						e.preventDefault()
						this.setState({
							address: e.target.value
						})
					}}
				/>

				<TextField 
					label="Код коробки"
					value={this.state.box_code}
					margin='normal'
					onChange={e => {
						e.stopPropagation()
						this.setState({ box_code: e.target.value })
					}}
				/>				

				{/* <Grid
					item
					container
				>
					<Grid
						item
						xs = {6}
						style = {{display: 'flex', flexDirection: 'column'}}
					>
						<FormControl
							margin = "normal"
						>
							<InputLabel id="boxBig_select_label">Коробка большая</InputLabel>
							<Select
								label = "Select"
								// labelId = "boxBig_select_label"
								value = {this.state.boxBig}
								onChange = {this.handleBoxBigSelectChange}
							>
								<MenuItem value = {0}>0</MenuItem>
								<MenuItem value = {1}>1</MenuItem>
								<MenuItem value = {2}>2</MenuItem>
								<MenuItem value = {3}>3</MenuItem>
								<MenuItem value = {4}>4</MenuItem>
								<MenuItem value = {5}>5</MenuItem>
								<MenuItem value = {6}>6</MenuItem>
								<MenuItem value = {7}>7</MenuItem>
								<MenuItem value = {8}>8</MenuItem>
								<MenuItem value = {9}>9</MenuItem>
								<MenuItem value = {10}>10</MenuItem>
								<MenuItem value = {11}>11</MenuItem>
								<MenuItem value = {12}>12</MenuItem>
								<MenuItem value = {13}>13</MenuItem>
								<MenuItem value = {14}>14</MenuItem>
								<MenuItem value = {15}>15</MenuItem>
								<MenuItem value = {16}>16</MenuItem>
								<MenuItem value = {17}>17</MenuItem>
								<MenuItem value = {18}>18</MenuItem>
								<MenuItem value = {19}>19</MenuItem>
								<MenuItem value = {20}>20</MenuItem>
								<MenuItem value = {21}>21</MenuItem>
								<MenuItem value = {22}>22</MenuItem>
								<MenuItem value = {23}>23</MenuItem>
								<MenuItem value = {24}>24</MenuItem>
								<MenuItem value = {25}>25</MenuItem>
								<MenuItem value = {26}>26</MenuItem>
								<MenuItem value = {27}>27</MenuItem>
								<MenuItem value = {28}>28</MenuItem>
								<MenuItem value = {29}>29</MenuItem>
								<MenuItem value = {30}>30</MenuItem>
								<MenuItem value = {31}>31</MenuItem>
								<MenuItem value = {32}>32</MenuItem>
								<MenuItem value = {33}>33</MenuItem>
								<MenuItem value = {34}>34</MenuItem>
								<MenuItem value = {35}>35</MenuItem>
								<MenuItem value = {36}>36</MenuItem>
								<MenuItem value = {37}>37</MenuItem>
								<MenuItem value = {38}>38</MenuItem>
								<MenuItem value = {39}>39</MenuItem>
								<MenuItem value = {40}>40</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid
						item
						xs = {6}
						style = {{display: 'flex', flexDirection: 'column'}}
					>
						<FormControl
							margin = "normal"
						>
							<InputLabel id="boxMedium_select_label">Коробка средняя</InputLabel>
							<Select
								label = "Select"
								// labelId = "boxMedium_select_label"
								value = {this.state.boxMedium}
								onChange = {this.handleBoxMediumSelectChange}
							>
								<MenuItem value = {0}>0</MenuItem>
								<MenuItem value = {1}>1</MenuItem>
								<MenuItem value = {2}>2</MenuItem>
								<MenuItem value = {3}>3</MenuItem>
								<MenuItem value = {4}>4</MenuItem>
								<MenuItem value = {5}>5</MenuItem>
								<MenuItem value = {6}>6</MenuItem>
								<MenuItem value = {7}>7</MenuItem>
								<MenuItem value = {8}>8</MenuItem>
								<MenuItem value = {9}>9</MenuItem>
								<MenuItem value = {10}>10</MenuItem>
								<MenuItem value = {11}>11</MenuItem>
								<MenuItem value = {12}>12</MenuItem>
								<MenuItem value = {13}>13</MenuItem>
								<MenuItem value = {14}>14</MenuItem>
								<MenuItem value = {15}>15</MenuItem>
								<MenuItem value = {16}>16</MenuItem>
								<MenuItem value = {17}>17</MenuItem>
								<MenuItem value = {18}>18</MenuItem>
								<MenuItem value = {19}>19</MenuItem>
								<MenuItem value = {20}>20</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				</Grid> */}

				<Grid
					item
					container
				>
					<Grid
						item
						xs = {6}
						style = {{display: 'flex', flexDirection: 'column'}}
					>
						<TextField
							label = "Дата проведения"
							type = "date"
							margin = "normal"
							value = {this.state.date}
							onChange = {e => {
								e.preventDefault()
								this.setState({
									date: e.target.value
								})
							}}
						/>
					</Grid>
					<Grid
						item
						xs = {6}
						style = {{display: 'flex', flexDirection: 'column'}}
					>
						<TextField
							label = "Время проведения"
							type = "time"
							margin = "normal"
							value = {this.state.time}
							onChange = {e => {
								e.preventDefault()
								this.setState({
									time: e.target.value
								})
							}}
						/>
					</Grid>					
				</Grid>

			</DialogContent>

			<DialogActions>

				<Button
					disabled = {!this.readyToUpdate()}
					onClick = {async (e) => {
						e.stopPropagation()

						let { box } = await api.boxes.get_byCode(this.state.box_code)

						if (box.id > 0) {
							if (typeof this.props.onUpdateShow === "function") {
								this.props.onUpdateShow({
									id: this.props.show.id,
									name: this.state.name,
									address: this.state.address,
									date: `${this.state.date} ${this.normalizeTime(this.state.time)}`,
									artists: this.state.artists,
									boxBig: this.state.boxBig,
									boxMedium: this.state.boxMedium,
									box_id: box.id,
								})
							}
						} else {
							this.setState({
								dialog: <CodeNotFoundDialog
									code={this.state.box_code}
									onClose={()=>{
										this.setState({dialog: undefined})
									}}
								/>
							})
						}

					}}
				>Сохранить</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default EditShowDialog
